import { gql } from 'graphql-request';

import {
  CategoryID,
  CategoryUUID,
  CategoryLocalizedName
} from '../../categories/categoriesTypes';

export interface FetchLifestyleAuthorsQueryResponse {
  uuid: CategoryUUID;
  id: CategoryID;
  localizedName: CategoryLocalizedName;
}

export const FETCH_LIFESTYLE_AUTHORS_QUERY = gql`
  query LifestyleAuthorsCategories(
    $filters: CategoriesFilters
    $sort: [CategoriesSortEnum!]
    $limit: Int
    $offset: Int
  ) {
    categories(filters: $filters, sort: $sort, limit: $limit, offset: $offset) {
      nodes {
        id
        localizedName
      }
      paginationInfo {
        currentPage
        nextPage
        totalCount
      }
      sql
    }
  }
`;
